'use client';

import { FaCoins, FaFileCircleCheck, FaHandshake } from "react-icons/fa6"
import Button from "./common/Button"

interface Props {
    actionButton?(): void
}

const WithBoxes: React.FC<Props> = ({ actionButton }: Props) => {

    //come funziona
    return (
        <div className='mx-5 lg:mx-40 mb-20 lg:mb-40 '>
            <div className='text-center mb-10 lg:mb-20'>
                <h1 className='lg:mb-5'>Come funziona?</h1>
                <div>Investi nel tuo futuro, con il supporto che meriti!</div>
            </div>
            <div className='flex gap-10 flex-col lg:flex-row'>
                <div className='bg-grayLight rounded-cornerMob lg:rounded-cornerDesk grid grid-cols-12 py-8 px-12'>
                    <div className='col-span-12'> <FaCoins className='text-grayDark' size={'3rem'} /></div>
                    <h2 className='col-span-12 mb-3'>Accedi a un fondo previdenziale agevolato</h2>
                    <div className='col-span-12'>All&apos;apertura zero costi amministrativi, risparmio di 50€/anno, dove versi almeno <strong>10€ al mese</strong>.</div>
                </div>
                <div className='bg-grayLight rounded-cornerMob lg:rounded-cornerDesk grid grid-cols-12 py-8 px-12'>
                    <div className='col-span-12'> <FaHandshake className='text-grayDark' size={'3rem'} /></div>
                    <h2 className='col-span-12 mb-3'>Ottieni un contributo extra</h2>
                    <div className='col-span-12'>Partecipando a Uwelfare ricevi un cofinanziamento sul tuo fondo se partecipi ad attività specifiche.</div>
                </div>
                <div className='bg-grayLight rounded-cornerMob lg:rounded-cornerDesk grid grid-cols-12 py-8 px-12'>
                    <div className='col-span-12'> <FaFileCircleCheck className='text-grayDark' size={'3rem'} /></div>
                    <h2 className='col-span-12 mb-3'>Più partecipi, più guadagni</h2>
                    <div className='col-span-12'>due volte l&apos;anno viene verificato il tuo status e ricevi il co-finanziamento accumulato.</div>
                </div>


            </div>
            {actionButton ?
                <div className='text-center mt-10 lg:mt-20'>
                    <Button text='Scopri di più' onClick={actionButton} />
                </div>
                : null}

        </div>
    )
}

export default WithBoxes;